import { PortfolioGalleryScreen } from '@/components/profile/portfolio-gallery-screen';

export default function ProfileGalleryPage() {
  return <PortfolioGalleryScreen />;
}
